// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3laL1","col":"CardReaderDesc_col__1oG-L","label":"CardReaderDesc_label__87RtL"};